<script setup>
/**
 * Imports
 */
import { onMounted } from "vue";
import { useTransportsStore } from "@/modules/autopark/store/transport.store";
import { CarCardComponent } from "@/components/features";
import { LoadingComponent } from "@/components/ui";
import { storeToRefs } from "pinia";

/**
 * Props & Emits
 */

/**
 * Variables
 */
const transportsStore = useTransportsStore();
const { asideTransports, loadingAside, asideHasMore } = storeToRefs(transportsStore);
const { fetchAsideTransports } = transportsStore;

const handleCarDragStart = (car, event) => {
  if (!event?.dataTransfer || !car?.id) return;

  try {
    event.dataTransfer.effectAllowed = "copy";
    const id = String(car.id);
    event.dataTransfer.setData("application/transport-id", id);
    // Fallback для браузеров, которые ограничивают custom MIME-типы
    event.dataTransfer.setData("text/plain", id);
  } catch (e) {
    // dataTransfer может быть недоступен в некоторых контекстах, просто игнорируем
  }
};

const handleCarDragEnd = () => {
  // Зарезервировано под возможную дополнительную логику, сейчас ничего не делаем
};

/**
 * Computed
 */

/**
 * Methods
 */
const handleScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target;

  // Если прокрутили до конца списка, загружаем еще данные
  if (scrollHeight - scrollTop <= clientHeight * 1.5 && !loadingAside.value && asideHasMore.value) {
    fetchAsideTransports(true);
  }
};

/**
 * Lifecycle Hooks
 */
onMounted(() => {
  fetchAsideTransports();
});
</script>

<template>
  <div v-access="'transport:index'" class="aside__cars">
    <span class="aside__cars-title">Автопарк</span>
    <div class="aside__cars-list" @scroll="handleScroll" ref="carsList">
      <CarCardComponent
        v-for="car in asideTransports"
        :key="car.id"
        :data="car"
        draggable="true"
        @dragstart="(event) => handleCarDragStart(car, event)"
        @dragend="handleCarDragEnd"
      />
      <LoadingComponent v-if="loadingAside" title="Загрузка..." />
      <div v-else-if="!asideTransports.length" class="aside__cars-empty">
        Нет доступных транспортных средств
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
.aside__cars {
  position: relative
	display: flex
	flex-direction column
	gap: 20px

  &:after {
    content: "";
    display block
    position absolute
    inset auto 0 0 0
    height 30px
    z-index 5
    background linear-gradient(transparent, var(--gray-2))
  }

	&-title {
		font-size: 1.5rem
		font-weight: 500;
		line-height: normal;
	}

	&-list {
		display: flex
		flex-direction: column
		gap: 20px
    max-height: 1400px;
    overflow-y: scroll;
		scrollbar-width: none
    padding: 0 20px;
    margin: 0 -20px;
    padding-bottom: 20px;
	}

	&-loading,
	&-empty {
		text-align: center
		padding: 10px
		color: var(--gray-light)
		font-size: 0.875rem
	}
}
</style>
